import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, message } from 'antd';

import Process from '@comm/workflow/Process';
import Modalshortfalls from '@comm/shortfalls';
import { getCompanyList } from '@store/modules/company_list';
import { getExpendType } from '@store/modules/finance/expend_type';
import { queryRecoupWorkflow, querySaveRecoup } from '@api/finance/recoup';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    this.recoupWorkflow();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  /**
   * 提交报销
   */
  handSubmit = item => {
    delete item.apportionType;
    this.saveRecoup(item);
  };

  recoupWorkflow = params => {
    const { instance } = this.state;
    queryRecoupWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveRecoup = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveRecoup(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      } else {
        this.setState({
          shortData: res.message,
          visible: true,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { dataInfo, isSubmitting, instance, shortData, visible } = this.state;
    return (
      <div>
        <FormBase data={dataInfo} handSubmit={this.handSubmit} isSubmitting={isSubmitting} />
        <Card>
          <Process instance={instance} />
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/finance/expenses/PageAdd.js